import { Component, OnInit, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { ConfigurationService } from '../../services/configuration.service';
import { TranslatesService } from './../../services/translates.service';
import { Http, Response } from '@angular/http';


@Component({
  selector: 'app-start-page',
  templateUrl: './start-page.component.html',
  styleUrls: ['./start-page.component.scss']
})
export class StartPageComponent implements OnInit {

  deviceInfo = null;
  isMobile = null;
  isDevice = null;
  isMobileDevice = null;
  titleIndex = 'start-page-title';

  constructor(public translate: TranslatesService, public titleService: Title) {
  }


  ngOnInit() {
    this.titleService.setTitle(this.translate.getText(this.titleIndex));
  }

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/views/start-page/start-page.component.ts